import React, { useState } from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { css } from 'glamor'
import getContent from 'pp-react-l10n'
import {
  Pagination,
  v2white,
  v2neutral100,
  v2blue400,
} from '@paypalcorp/pp-react'
import {
  phoneLandscapeMaxAndSmaller,
  phoneLandscapeMinAndSmaller,
} from 'lib/styles/media-queries'

const l10n = getContent('pages/shops/common')

const heights = {
  desktop: '350px',
  phoneMax: '224px',
  phoneMin: '200px',
}

const Container = glamorous.div({
  height: `${heights.desktop}`,
  width: '100%',
  position: 'relative',
  [phoneLandscapeMaxAndSmaller]: {
    height: `${heights.phoneMax}`,
  },
  [phoneLandscapeMinAndSmaller]: {
    height: `${heights.phoneMin}`,
  },
})

const FadeIn = css.keyframes({ from: { opacity: 0 }, to: { opacity: 1 } })
const BackgroundPhoto = glamorous.div(({ image, fadeIn = true }) => ({
  position: 'absolute',
  boxSizing: 'border-box',
  width: '100%',
  minWidth: '700px',
  height: `${heights.desktop}`,
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundImage: `url(${encodeURI(image)})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  ...(fadeIn && { animation: `${FadeIn} 0.2s` }),
  [phoneLandscapeMaxAndSmaller]: {
    minWidth: '131%',
    height: `${heights.phoneMax}`,
  },
  [phoneLandscapeMinAndSmaller]: {
    minWidth: 'calc(100% + 41px)',
    height: `${heights.phoneMin}`,
  },
}))

const PaginationContainer = css({
  position: 'absolute',
  bottom: '14px',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
})

const Page = css({
  height: '6px',
  width: '6px',
  borderRadius: '100%',
  backgroundColor: v2neutral100,
  margin: '0 4px',
  color: v2white,
  fontSize: 0,
  ':hover': {
    color: v2white,
    textDecoration: 'none',
  },
})

const ActivePage = css({
  backgroundColor: v2blue400,
  color: v2white,
  transition: 'none',
})

const PageArrow = {
  height: '40px',
  width: '40px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: v2white,
  background: 'rgba(12, 12, 13, 0.3)',
  fontWeight: 100,
  fontSize: '1.25rem',
  position: 'absolute',
  zIndex: 5,
  top: `calc(-${heights.desktop} / 2)`,
  ':hover': {
    background: 'rgba(12, 12, 13, 0.5)',
  },
  [phoneLandscapeMaxAndSmaller]: {
    top: `calc(-${heights.phoneMax} / 2)`,
  },
  [phoneLandscapeMinAndSmaller]: {
    top: `calc(-${heights.phoneMin} / 2)`,
  },
}

const PageArrowLeft = {
  left: '-18%',
  [phoneLandscapeMaxAndSmaller]: {
    left: '-10%',
  },
  [phoneLandscapeMinAndSmaller]: {
    left: '-8px',
  },
}

const PageArrowRight = {
  right: '-18%',
  [phoneLandscapeMaxAndSmaller]: {
    right: '-10%',
  },
  [phoneLandscapeMinAndSmaller]: {
    right: '-8px',
  },
}

const PageSpace = css({
  display: 'none',
})

ProductCoverPhoto.propTypes = {
  productPhotos: PropTypes.arrayOf(
    PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
    }),
  ),
}

ProductCoverPhoto.defaultProps = {
  productPhotos: [
    {
      imageUrl:
        'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-1.png',
    },
    {
      imageUrl:
        'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-2.png',
    },
    {
      imageUrl:
        'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-1.png',
    },
  ],
}

function ProductCoverPhoto(props) {
  const [currentPage, setCurrentPage] = useState(0)

  const handleChange = page => {
    setCurrentPage(page - 1)
  }

  const productPhotoCount = props.productPhotos.length

  return (
    <Container>
      {productPhotoCount && (
        <>
          <BackgroundPhoto
            image={props.productPhotos[currentPage].imageUrl}
            data-test-id="shops-product-photos"
          />
          <Pagination
            totalPageCount={productPhotoCount}
            currentPage={currentPage + 1}
            onChange={handleChange}
            prevPageLabel={l10n('prevPageLabel')}
            nextPageLabel={l10n('nextPageLabel')}
            paginationLabel={l10n('paginationLabel')}
            className={`${PaginationContainer}`}
            pageClassName={`${Page}`}
            activePageClassName={`${ActivePage}`}
            arrowLeftClassName={`${css(PageArrow, PageArrowLeft)}`}
            arrowRightClassName={`${css(PageArrow, PageArrowRight)}`}
            arrowSpaceClassName={`${PageSpace}`}
          />
        </>
      )}
    </Container>
  )
}

export default ProductCoverPhoto
